module.exports = __webpack_public_path__ + "img/质量稽核.5b0b62e9.svg";